<template>
  <div>
    <el-card class="box-card">
      <div slot="header" class="flex justify-between">
        <span>{{ $t('merchantManage.queryCondition') }}</span>
      </div>
      <div class="">
        <el-form :inline="true" :model="merchantManageInfo.conditions" class="flex justify-start">
          <el-form-item>
            <el-input v-model="merchantManageInfo.conditions.storeId" :placeholder="$t('merchantManage.inputStoreId')"
              clearable />
          </el-form-item>
          <el-form-item>
            <el-input v-model="merchantManageInfo.conditions.name" :placeholder="$t('merchantManage.inputName')"
              clearable />
          </el-form-item>
          <el-form-item>
            <el-input v-model="merchantManageInfo.conditions.tel" :placeholder="$t('merchantManage.inputTel')"
              clearable />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="_queryMerchantMethod">
              <i class="el-icon-search"></i>
              {{ $t('merchantManage.search') }}
            </el-button>
            <el-button @click="_resetMerchantMethod">
              <i class="el-icon-refresh"></i>
              {{ $t('merchantManage.reset') }}
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <el-card class="box-card" style="margin-top: 20px;">
      <div slot="header" class="flex justify-between">
        <span>{{ $t('merchantManage.merchantCompany') }}</span>
        <div>
          <el-button type="text" @click="vc.toDoc('/pages/mall/shop/openShop_mall.html')">
            {{ $t('merchantManage.document') }}
          </el-button>
          <el-button type="primary" size="small" @click="_openAddMerchantModal">
            <i class="el-icon-plus"></i>
            {{ $t('merchantManage.add') }}
          </el-button>
        </div>
      </div>
      <div class="">
        <el-table :data="merchantManageInfo.propertyCompanys" border style="width: 100%">
          <el-table-column prop="storeId" :label="$t('merchantManage.id')" align="center" />
          <el-table-column prop="name" :label="$t('merchantManage.name')" align="center" />
          <el-table-column prop="address" :label="$t('merchantManage.address')" align="center" />
          <el-table-column prop="tel" :label="$t('merchantManage.admin')" align="center" />
          <el-table-column prop="tel" :label="$t('merchantManage.tel')" align="center" />
          <el-table-column prop="createTime" :label="$t('merchantManage.createTime')" align="center" />
          <el-table-column :label="$t('merchantManage.operation')" align="center" width="300">
            <template slot-scope="scope">
              <el-button v-if="scope.row.state != '48002'" size="mini"
                @click="_openUpdateStoreStateModel(scope.row, '48002')">
                {{ $t('merchantManage.limitLogin') }}
              </el-button>
              <el-button v-else size="mini" @click="_openUpdateStoreStateModel(scope.row, '48001')">
                {{ $t('merchantManage.recoverLogin') }}
              </el-button>
              <el-button size="mini" @click="_resetStaffPwd(scope.row)">
                {{ $t('merchantManage.resetPwd') }}
              </el-button>
              <el-button size="mini" @click="_toStoreShopPage(scope.row)">
                {{ $t('merchantManage.manageShop') }}
              </el-button>
              <el-button size="mini" type="danger" @click="_openDeleteMerchantModel(scope.row)">
                {{ $t('merchantManage.delete') }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <div class="pagination-container">
          <el-pagination background layout="total, sizes, prev, pager, next, jumper" :total="merchantManageInfo.total"
            :page-size="merchantManageInfo.conditions.row" @current-change="handleCurrentChange" />
        </div>
      </div>
    </el-card>

    <add-merchant-shop ref="addMerchantShop" @refresh="_listMerchants" />
    <update-store-state ref="updateStoreState" @refresh="_listMerchants" />
    <reset-staff-pwd ref="resetStaffPwd" />
    <delete-merchant ref="deleteMerchant" @refresh="_listMerchants" />
  </div>
</template>

<script>
import { listStores, listStoreStaffs } from '@/api/admin/merchantManage/merchantManageApi'
import AddMerchantShop from '@/components/admin/addMerchantShop/addMerchantShop'
import UpdateStoreState from '@/components/admin/updateStoreState/updateStoreState'
import ResetStaffPwd from '@/components/frame/resetStaffPwd/resetStaffPwd'
import DeleteMerchant from '@/components/admin/deleteMerchant/deleteMerchant'

export default {
  name: 'MerchantManage',
  components: {
    AddMerchantShop,
    UpdateStoreState,
    ResetStaffPwd,
    DeleteMerchant
  },
  data() {
    return {
      merchantManageInfo: {
        propertyCompanys: [],
        total: 0,
        conditions: {
          storeId: '',
          name: '',
          tel: '',
          storeTypeCd: '800900000005',
          statusCd: '0',
          page: 1,
          row: 10
        }
      }
    }
  },
  created() {
    this._listMerchants()
  },
  methods: {
    async _listMerchants(page = 1, rows = 10) {
      this.merchantManageInfo.conditions.page = page
      this.merchantManageInfo.conditions.row = rows
      try {
        const res = await listStores(this.merchantManageInfo.conditions)
        this.merchantManageInfo.propertyCompanys = res.data
        this.merchantManageInfo.total = res.total
      } catch (error) {
        console.error(error)
      }
    },
    _queryMerchantMethod() {
      this._listMerchants()
    },
    _resetMerchantMethod() {
      this.merchantManageInfo.conditions = {
        storeId: '',
        name: '',
        tel: '',
        storeTypeCd: '800900000005',
        statusCd: '0',
        page: 1,
        row: 10
      }
      this._listMerchants()
    },
    _openAddMerchantModal() {
      this.$refs.addMerchantShop.open()
    },
    _openDeleteMerchantModel(row) {
      this.$refs.deleteMerchant.open({
        storeId: row.storeId,
        storeTypeCd: row.storeTypeCd
      })
    },
    _toStoreShopPage(store) {
      this.$router.push(`/pages/admin/merchantShop?storeId=${store.storeId}`)
    },
    _openUpdateStoreStateModel(row, state) {
      this.$refs.updateStoreState.open({
        storeId: row.storeId,
        state: state,
        stateName: state === '48002'
          ? this.$t('merchantManage.limitLogin')
          : this.$t('merchantManage.recoverLogin')
      })
    },
    async _resetStaffPwd(row) {
      try {
        const res = await listStoreStaffs({
          page: 1,
          row: 1,
          relCd: '600311000001',
          storeId: row.storeId
        })
        if (res.data && res.data.length > 0) {
          this.$refs.resetStaffPwd.open({
            username: res.data[0].staffName,
            userId: res.data[0].staffId,
            curUserName: res.data[0].staffName
          })
        }
      } catch (error) {
        console.error(error)
      }
    },
    handleCurrentChange(val) {
      this._listMerchants(val, this.merchantManageInfo.conditions.row)
    }
  }
}
</script>

<style scoped>
.pagination-container {
  margin-top: 20px;
  text-align: right;
}

.box-card {
  margin-bottom: 20px;
}
</style>